import { useFrozenScreenDimensions } from '@savvy/deprecated-shared/hooks/use-frozen-screen-dimensions';

const MINIMUM_SCREEN_REAL_ESTATE = 300000;

export function useIsVerySmallScreen() {
  const { windowHeight, windowWidth } = useFrozenScreenDimensions();
  return windowHeight * windowWidth < MINIMUM_SCREEN_REAL_ESTATE;
}
